import { twMerge } from 'tailwind-merge';

export type ButtonStyleVariant = 'primary' | 'outline' | 'secondary';
export type ButtonStyleSubVariant = 'active' | 'pressed';

type VariantStateClasses = {
  base: string;
  active?: string;
  pressed?: string;
  disabled?: string;
};

const buttonVariants: Record<ButtonStyleVariant, VariantStateClasses> = {
  primary: {
    base: 'bg-blue-500 text-white',
    active: 'bg-blue-400',
    pressed: 'bg-blue',
    disabled: 'bg-blue-100',
  },
  outline: {
    base: 'border border-gray bg-white text-gray',
    active: 'border-gray-400 text-gray-400',
    pressed: 'border-gray-700 text-gray-700',
    disabled: 'border-gray-200 text-gray-200',
  },
  secondary: {
    base: 'bg-orange text-white',
    active: 'bg-orange-500',
    pressed: 'bg-orange-700',
    disabled: 'bg-orange-100',
  },
};

export const buttonStylesVariants = (
  variant: ButtonStyleVariant,
  subVariant?: ButtonStyleSubVariant,
  isDisabled?: boolean,
): string => {
  const variantClasses = buttonVariants[variant];

  return twMerge(
    variantClasses.base,
    subVariant && variantClasses[subVariant],
    isDisabled && variantClasses.disabled,
  );
};
